import Modal from 'services/modal';
import BaseService from 'services/base';

const SupplierService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},
    //发布物料准入报告
    publishBuyoffReport(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布？', ok, dispatch);
    },
    //删除物料准入报告
    deleteBuyoffReport(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认删除？', ok, dispatch);
    },
    //退回物料准入报告
    rejectBuyoffReport(postbody, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认退回？', ok, dispatch);
    },
    //内部商城引入单发布
    handleIntroducePublish(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布？', ok, dispatch);
    },
    //供应商违约/索赔通知 发布
    publishPenaltyNotice(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布？', ok, dispatch);
    },
    //确认发布退出通知单
    eliminatePublish(postbody, cb: Function = () => {}, dispatch) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布退出通知单？', ok, dispatch);
    },
    //供应商变更同意
    customerChangedAgree(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = () => {
        let config = {
          ...postbody,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作？', ok, dispatch);
    },
    //供应商变更同意
    customerChangedReturn(
      postbody,
      cb: Function = () => {},
      dispatch: Function
    ) {
      let ok = (reason?) => {
        if (!reason) {
          Modal.showError('退回原因不能为空', dispatch);
          return;
        }
        let config = {
          ...postbody,
          returnDesc: reason,
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showReject('确认退回？', ok, '退回', 'showReject', '', dispatch);
    }
  },
  BaseService
);

export default SupplierService;
